// eslint-disable-next-line import/no-relative-parent-imports
import packageJson from '../../package.json';
import {secrets} from './secrets';
import {ConfigType} from '@resurs-internal/rb-app-api/config';

const packageVersion = packageJson['version'];
export const NODE_ENV = process.env.NODE_ENV;
export const environment = secrets.REACT_APP_ENV;

const hostname = window.location.hostname;
export const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';
export const isDevelopmentHost =
  hostname === 'mypages-client-dev.d.eks.aws.cld.resurs.com';
export const isIntegrationHost =
  hostname === 'app.integration.resurs.com' ||
  hostname === 'web-integration-mypages-client.i.eks.aws.cld.resurs.com';
export const isBetaHost = hostname === 'app.beta.resurs.com';
export const isAppHost = hostname === 'app.resurs.com';
export const isSEHost = hostname === 'onlinebank.resursbank.se';
export const isNOHost = hostname === 'onlinebank.resursbank.no';
export const isDKHost = hostname === 'onlinebank.resursbank.dk';
export const isFIHost = hostname === 'onlinebank.resursbank.fi';
export const isAWSProdHost =
  hostname === 'web-prod-mypages-client.p.eks.aws.cld.resurs.com';
export const isOnlineBankHost = isSEHost || isNOHost || isDKHost || isFIHost;
export const isProductionHost =
  isOnlineBankHost || isAppHost || isBetaHost || isAWSProdHost;

export const isLocal = isLocalHost;
export const isDevelopment = isDevelopmentHost;
export const isIntegration = isIntegrationHost;
export const isProduction = isProductionHost;

const local = {
  env: 'integration',
  apiKey: '1886ddcb2422e942af8e1a72a3ce07a4',
  clientId: '7b84d3f88474f8d3b46e33e3645d95c3',
  enableLog: false,
  clientHost: 'http://localhost:3000',
  bankIdHost:
    'https://checkpoint-romeo-frontend-service.integration.resurs.com',
  customerFrontendService:
    'https://apigw.integration.resurs.com/api/customer_frontend_service',
  apiURL: 'https://apigw.integration.resurs.com/api',
  zendeskURL: 'https://resursbank1769435116.zendesk.com',
  zendeskID: '87fdec29-571d-4efd-9801-6c8af8a63ce7',
  zendeskLanguageFieldId: '25081490911900',
  zendeskSourceFieldId: '25081483600540',
  zendeskProtectedFieldId: '25081484219932',
  zendeskIntegrationId: '6977702f50eddafbb71cfae6',
  links: {
    chatToken:
      'https://apigw.integration.resurs.com/api/customer_service/chats/token',
    entrypoint:
      'https://apigw.integration.resurs.com/api/entrypoint_service/entrypoints/app/',
    unleash: 'https://apigw.integration.resurs.com/api/unleash/frontend',
    mbidRefresh:
      'https://apigw.integration.resurs.com/api/auth_service/token/refresh',
    oAuthToken: 'https://apigw.integration.resurs.com/api/oauth2/token',
    oAuthRedirect: 'https://apigw.integration.resurs.com/api/oauth2/auth',
    oAuthTokenRevoke:
      'https://apigw.integration.resurs.com/api/oauth2/token/revoke',
  },
} as const;

const development = {
  env: 'development',
  apiKey: '59d51b41e42f4f4bb07104371b19d152',
  clientId: '7b84d3f88474f8d3b46e33e3645d95c3',
  enableLog: false,
  clientHost: 'http://localhost:3000',
  bankIdHost: 'https://checkpoint-romeo-frontend-dev.d.eks.aws.cld.resurs.com',
  customerFrontendService:
    'https://api.d.eks.aws.cld.resurs.com/api/customer_frontend_service',
  apiURL: 'https://api.d.eks.aws.cld.resurs.com/api',
  zendeskURL: 'https://resursbank1769435116.zendesk.com',
  zendeskID: '87fdec29-571d-4efd-9801-6c8af8a63ce7',
  zendeskLanguageFieldId: '25081490911900',
  zendeskSourceFieldId: '25081483600540',
  zendeskProtectedFieldId: '25081484219932',
  zendeskIntegrationId: '6977702f50eddafbb71cfae6',
  links: {
    chatToken:
      'https://api.d.eks.aws.cld.resurs.com/api/customer_service/chats/token',
    entrypoint:
      'https://api.d.eks.aws.cld.resurs.com/api/entrypoint_service/entrypoints/app/',
    unleash: 'https://api.d.eks.aws.cld.resurs.com/api/unleash/frontend',
    mbidRefresh:
      'https://api.d.eks.aws.cld.resurs.com/api/auth_service/token/refresh',
    oAuthToken: 'https://api.d.eks.aws.cld.resurs.com/api/oauth2/token',
    oAuthRedirect: 'https://api.d.eks.aws.cld.resurs.com/api/oauth2/auth',
    oAuthTokenRevoke:
      'https://api.d.eks.aws.cld.resurs.com/api/oauth2/token/revoke',
  },
} as const;

const integration = {
  env: 'integration',
  apiKey: '1886ddcb2422e942af8e1a72a3ce07a4',
  clientId: '7b84d3f88474f8d3b46e33e3645d95c3',
  clientHost: 'https://app.integration.resurs.com',
  enableLog: false,
  bankIdHost:
    'https://checkpoint-romeo-frontend-service.integration.resurs.com',
  customerFrontendService:
    'https://apigw.integration.resurs.com/api/customer_frontend_service',
  apiURL: 'https://apigw.integration.resurs.com/api',
  zendeskURL: 'https://resursbank1769435116.zendesk.com',
  zendeskID: '87fdec29-571d-4efd-9801-6c8af8a63ce7',
  zendeskLanguageFieldId: '25081490911900',
  zendeskSourceFieldId: '25081483600540',
  zendeskProtectedFieldId: '25081484219932',
  zendeskIntegrationId: '6977702f50eddafbb71cfae6',
  links: {
    chatToken:
      'https://apigw.integration.resurs.com/api/customer_service/chats/token',
    entrypoint:
      'https://apigw.integration.resurs.com/api/entrypoint_service/entrypoints/app/',
    unleash: 'https://apigw.integration.resurs.com/api/unleash/frontend',
    mbidRefresh:
      'https://apigw.integration.resurs.com/api/auth_service/token/refresh',
    oAuthToken: 'https://apigw.integration.resurs.com/api/oauth2/token',
    oAuthRedirect: 'https://apigw.integration.resurs.com/api/oauth2/auth',
    oAuthTokenRevoke:
      'https://apigw.integration.resurs.com/api/oauth2/token/revoke',
  },
} as const;

const production = {
  env: 'production',
  apiKey: 'ae9f4acc12da1f9da33ebefca07c1548',
  clientId: 'c26f3364bcac01f38da16333a38b5c57',
  clientHost: 'https://onlinebank.resursbank.se',
  enableLog: false,
  bankIdHost: 'https://checkpoint-romeo.resurs.com',
  customerFrontendService:
    'https://apigw.resurs.com/api/customer_frontend_service',
  apiURL: 'https://apigw.resurs.com/api',
  zendeskURL: 'https://resursbank.zendesk.com',
  zendeskID: 'c7271feb-c154-4a91-9293-6d72a859fd36',
  zendeskLanguageFieldId: '24255383271324',
  zendeskSourceFieldId: '24255302087196',
  zendeskProtectedFieldId: '23651178552348',
  zendeskIntegrationId: '67c03724665fe94f2d5fc019',
  links: {
    chatToken: 'https://apigw.resurs.com/api/customer_service/chats/token',
    entrypoint:
      'https://apigw.resurs.com/api/entrypoint_service/entrypoints/app/',
    unleash: 'https://apigw.resurs.com/api/unleash/frontend',
    mbidRefresh: 'https://apigw.resurs.com/api/auth_service/token/refresh',
    oAuthToken: 'https://apigw.resurs.com/api/oauth2/token',
    oAuthRedirect: 'https://apigw.resurs.com/api/oauth2/auth',
    oAuthTokenRevoke: 'https://apigw.resurs.com/api/oauth2/token/revoke',
  },
} as const;

export const config: ConfigType & {
  env: 'development' | 'integration' | 'production';
  clientHost: string;
  sentryDSN: string;
  sentryId: string;
  bankIdHost: string;
  customerFrontendService: string;
  apiURL: string;
  zendeskURL: string;
  zendeskID: string;
  zendeskLanguageFieldId: string;
  zendeskSourceFieldId: string;
  zendeskIntegrationId: string;
} = {
  ...local,
  ...(isDevelopment && development),
  ...(isIntegration && integration),
  ...(isProduction && production),
  clientName: 'mypages',
  clientVersion: packageVersion,
  clientPlatform: 'WEB',
  chatClientId: 'mypages',
  requestTimeout: 60000,
  sentryDSN:
    'https://af95996364bd4dabb64dd392dbe4b11e@o566388.ingest.sentry.io/6392096',
  sentryId: '6392096',
};
